import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dropdown", "icon"];
  static values = {
    rotationClass: String,
  };

  connect() {
    document.addEventListener("click", this.hide.bind(this));
  }

  disconnect() {
    document.removeEventListener("click", this.hide.bind(this));
  }

  toggle() {
    this.dropdownTarget.classList.toggle("hidden");
    this.toggleIconRotation();
  }

  collapseToggle() {
    const isClosed = this.dropdownTarget.classList.contains("max-h-0");

    this.dropdownTarget.classList.remove("hidden");
    this.dropdownTarget.classList.toggle("max-h-0", !isClosed);
    this.dropdownTarget.classList.toggle("max-h-full", isClosed);

    this.toggleIconRotation();
  }

  hide(event) {
    if (!this.element.contains(event.target)) {
      this.dropdownTarget.classList.add("hidden");
      this.resetIconRotation();
    }
  }

  toggleIconRotation() {
    if (!this.hasIconTarget) return;

    const rotate = this.rotationClassValue || "rotate-180";
    this.iconTarget.classList.toggle(rotate);
  }

  resetIconRotation() {
    if (!this.hasIconTarget) return;

    const rotate = this.rotationClassValue || "rotate-180";
    this.iconTarget.classList.remove(rotate);
  }
}
